// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  worldId: __t.u64().name("world_id"),
  encounterId: __t.u64().name("encounter_id"),
  haulItemId: __t.u64().name("haul_item_id"),
  itemId: __t.option(__t.u64()).name("item_id"),
  def: __t.u16(),
  name: __t.string(),
  lore: __t.string(),
  tags: __t.array(__t.string()),
  leader: __t.string(),
  jobId: __t.u64().name("job_id"),
  written: __t.bool(),
  at: __t.timestamp(),
});
